import React from "react";
import { Droppable } from "react-beautiful-dnd";
import { CalendarEditorMonthItem } from "./";

// class MonthsList extends React.Component {
//   shouldComponentUpdate(nextProps) {
//     if (nextProps.items === this.props.items) {
//       return false;
//     }
//     return true;
//   }

//   render() {
//     return this.props.items.map((month, index) => {
//       return (
//         <CalendarEditorMonthItem
//           // key={`month-item-${month.rhf_id}`}
//           key={`months[${index}]`}
//           draggableId={`month-item-${index}`}
//           // draggableId={index}
//           month={month}
//           index={index}
//         />
//       );
//     });
//   }
// }

export class CalendarEditorMonthList extends React.Component {
  shouldComponentUpdate(nextProps) {
    return true;
    if (this.props.items.length !== nextProps.items.length) return false;
    let ret = true;
    for (let i = 0; i < this.props.items.length; i++) {
      if (!this.props.items[i] || !nextProps.items[i]) {
        // ret = false;
        break;
      }
      if (this.props.items[i].rhf_id && nextProps.items[i].rhf_id) {
        if (this.props.items[i].rhf_id === nextProps.items[i].rhf_id) {
          ret = false;
        } else {
          ret = true;
          break;
        }
      }
    }
    console.log("Updating list...", ret);
    return ret;
  }
  render() {
    // console.log(this.props.items);
    let handleMonthRemove = this.props.onMonthDelete
      ? this.props.onMonthDelete
      : false;
    return (
      <ul className="chronos-calendar-editor-months-list">
        <Droppable
          droppableId="chronos-calendar-editor-form"
          direction="vertical"
        >
          {(provided, snapshot) => (
            <div {...provided.droppableProps} ref={provided.innerRef}>
              {this.props.items.map((month, index) => (
                <CalendarEditorMonthItem
                  // key={`month-item-${month.rhf_id}`}
                  key={`months[${index}]`}
                  draggableId={`month-item-${index}`}
                  // draggableId={index}
                  onDelete={handleMonthRemove}
                  month={month}
                  index={index}
                />
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </ul>
    );
  }
}

// export function CalendarEditorMonthList({ items }) {
//   console.log("ITEMS FOR LIST", items);
//   const DroppableContent = (provided, snapshot) => (
//     <ul
//       className="chronos-calendar-editor-months-list"
//       ref={provided.innerRef}
//       {...provided.droppableProps}
//     >
//       <MonthsList items={items} />
//       {provided.placeholder}
//     </ul>
//   );

//   // const DroppableContentConnected = React.useCallback(DroppableContent, [
//   //   items,
//   // ]);

//   return (
//     <Droppable
//       droppableId="chronos-calendar-editor-form"
//       direction="vertical"
//       type="month"
//     >
//       {/* {DroppableContentConnected} */}
//       {DroppableContent}
//       {/* {(provided) => (
//         <ul
//           className="chronos-calendar-editor-months-list"
//           ref={provided.innerRef}
//           {...provided.droppableProps}
//         >
//           <MonthsList items={items} />
//           {provided.placeholder}
//         </ul>
//       )} */}
//     </Droppable>
//   );
// }
